import { isLg, isMd, isMobile, isXs } from 'lm-ui-kit/src/utils/response-query';

/**
 * Отобразит контент только на мобильном девайсе
 */
export const atMobile = atMedia(isMobile);
export const atXs = atMedia(isXs);
export const notXs = atMedia(() => !isXs());
/**
 * Отобразит контент только на десктопе
 */
export const atDesktop = atMedia(() => isLg() || isMd());
/**
 * Отобразит контент везде кроме desktop
 */
export const notDesktop = atMedia(() => !isLg() && !isMd());
/**
 * Отобразит контент только на планшете
 */
export const atTablet = atMedia(isMd);

/**
 * @param {() => boolean} media
 */
function atMedia(media) {
  /**
   * @param {TemplateResult} truthlyContent
   * @param {TemplateResult} [falsyContent = null]
   *
   * @return {TemplateResult|null}
   */
  const result = (truthlyContent, falsyContent = null) => (media() ? truthlyContent : falsyContent);

  return result;
}
